define("shared/components/shared/social/facebook-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalBg">
    <div class="o--modal--close" {{action @closeFacebook}}></div>
    <div class="o--modalWrapper">
      <div class="o--modalVer">
        <div class="o--modalCard">
          <header class="o--modalHeader">
            <p class="o--modalHeader__title">
              {{t "account.controllers.groups.facebook.add_profile"}}
            </p>
            <p class="u--m__b__lg u--text--md">
              {{t "account.controllers.groups.facebook.add_profile_text"}}
            </p>
          </header>
          <div class="o--modalBody has--scroll">
            <Shared::Social::FacebookPicker
              @addProfile={{action @addProfile}}
              @closeFacebook={{@closeFacebook}}
              @isAddFacebookProfileRunning={{@isAddFacebookProfileRunning}}
            />
          </div>
          <footer class="o--modalFooter">
            <div class="o--btnBar u--float--left">
              <button class="o--btn o--btn--mute" type="button" {{action @closeFacebook}}>
                {{t "shared_words.cancel"}}
              </button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "zZFNIVH0",
    "block": "[[[10,0],[14,0,\"o--modalBg\"],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--modal--close\"],[4,[38,0],[[30,0],[30,1]],null],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--modalWrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--modalVer\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--modalCard\"],[12],[1,\"\\n        \"],[10,\"header\"],[14,0,\"o--modalHeader\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__lg u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile_text\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--modalBody has--scroll\"],[12],[1,\"\\n          \"],[8,[39,2],null,[[\"@addProfile\",\"@closeFacebook\",\"@isAddFacebookProfileRunning\"],[[28,[37,0],[[30,0],[30,2]],null],[30,1],[30,3]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"footer\"],[14,0,\"o--modalFooter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--btnBar u--float--left\"],[12],[1,\"\\n            \"],[11,\"button\"],[24,0,\"o--btn o--btn--mute\"],[24,4,\"button\"],[4,[38,0],[[30,0],[30,1]],null],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"shared_words.cancel\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@closeFacebook\",\"@addProfile\",\"@isAddFacebookProfileRunning\"],false,[\"action\",\"t\",\"shared/social/facebook-picker\"]]",
    "moduleName": "shared/components/shared/social/facebook-modal.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});